/**
 * Sets the CSS custom property --vh to the actual viewport height
 * This fixes issues with mobile browser address bars that affect 100vh
 */
export const setViewportHeight = (): void => {
  // First get the viewport height and multiply it by 1% to get a value for a vh unit
  const vh = window.innerHeight * 0.01;
  // Then set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

/**
 * Initializes the viewport height fix and sets up event listeners
 * to update it when the viewport size changes (e.g. when the address bar shows/hides)
 */
export const initViewportHeightFix = (): void => {
  // Set initial viewport height
  setViewportHeight();
  
  // Update the height on resize and orientation change
  window.addEventListener('resize', setViewportHeight);
  window.addEventListener('orientationchange', setViewportHeight);
  
  // Also update after a short delay to account for address bar behavior
  setTimeout(setViewportHeight, 500);
};

export default initViewportHeightFix; 